import * as React from 'react';

import {
  BooleanInput,
  Edit,
  ReferenceArrayInput,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  required,
  useRecordContext,
  useTranslate,
} from 'react-admin';

import { IRecurringNotifications } from '../../types';

const Title = () => {
  const record = useRecordContext<IRecurringNotifications>();
  const translate = useTranslate();
  return (
    <span>
      {translate('resources.recurring_notifications.name')}{' '}
      {record ? `"${record.name}"` : ''}
    </span>
  );
};

const RecurringNotificationsEdit = () => {
  const translate = useTranslate();

  return (
    <Edit title={<Title />}>
      <SimpleForm>
        <TextInput
          source="name"
          label={translate('resources.recurring_notifications.fields.name')}
          validate={[required()]}
          disabled
          inputProps={{
            maxLength: 30,
          }}
        />
        <TextInput
          source="notificationTitle"
          label={translate(
            'resources.recurring_notifications.fields.notificationTitle'
          )}
          validate={[required()]}
          inputProps={{
            maxLength: 30,
          }}
        />
        <TextInput
          source="notificationText"
          label={translate(
            'resources.recurring_notifications.fields.notificationText'
          )}
          validate={[required()]}
          inputProps={{
            maxLength: 100,
          }}
          fullWidth
        />
        <p>
          {'{date}'} - дата, {'{balance}'} - баланс
        </p>
        <br />
        <BooleanInput
          fullWidth
          label={translate('resources.recurring_notifications.fields.active')}
          source="active"
          defaultValue={true}
        />
        <ReferenceArrayInput
          source="discountGroup"
          reference="discounts"
          perPage={100}
        >
          <SelectArrayInput
            label={translate('resources.recurring_notifications.fields.sendTo')}
            optionText={(discount) => `${discount.name}`}
            // disabled={true}
          />
        </ReferenceArrayInput>
        {/* <ReferenceInput source="sendTo" reference="customers" perPage={1000}>
          <SelectInput
            label={translate('resources.recurring_notifications.fields.sendTo')}
            optionText={(customer) =>
              `${customer.name} ${customer?.companyName ?? ''} (${
                customer.phone
              })`
            }
            resettable
            disabled={true}
          />
        </ReferenceInput> */}
      </SimpleForm>
    </Edit>
  );
};

export default RecurringNotificationsEdit;
